// Integration selectors live here.

// Base selector for integration slice state.
export const selectIntegrationState = (state) => state.integration; // Access the integration slice state

// Selector for integrations list.
export const selectIntegrations = (state) => selectIntegrationState(state).integrations;

// Selector for device type map.
export const selectDeviceTypeMap = (state) => selectIntegrationState(state).deviceTypeMap;

// Selector for system type map.
export const selectSystemTypeMap = (state) => selectIntegrationState(state).systemTypeMap;

// Selector for integration fetching state.
export const selectIntegrationFetching = (state) => selectIntegrationState(state).fetching;

export const selectVisibleDeviceTypes = (state) => selectIntegrationState(state).visibleDeviceTypes;

export const selectDeviceSettings = (state) => selectIntegrationState(state).deviceSettings;

export const selectGroupSettings = (state) => selectIntegrationState(state).groupSettings;

export const selectStageOpen = (state) => selectIntegrationState(state).stageOpen;

// Cached device data time-range selectors (milliseconds since epoch)
export const selectDeviceDataStartTime = (state) => selectIntegrationState(state).dataStartTime;
export const selectDeviceDataEndTime = (state) => selectIntegrationState(state).dataEndTime;

// Selector for initial history loaded state
export const selectInitialHistoryLoaded = (state) =>
  selectIntegrationState(state).initialHistoryLoaded;

// Composite selector to check if fetching AND historical data hasn't loaded yet
// True when we're fetching and haven't got historical data - useful to show loading overlays on data sections
export const selectHistoryDataLoading = (state) => {
  const integration = selectIntegrationState(state);
  return integration.fetching && !integration.initialHistoryLoaded;
};
